// NavLinks.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react'; // Changed from Aperture
import { useTranslation } from 'react-i18next';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils'; // Assuming this utility exists

interface NavLinksProps {
  isMobile?: boolean;
}

export const NavLinks: React.FC<NavLinksProps> = ({ isMobile = false }) => {
  const { t } = useTranslation();

  if (isMobile) {
    // Style for inside the Sheet
    return (
      <Link 
        to="/studio" 
        className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-base font-medium text-muted-foreground transition-all hover:text-primary"
      >
        <ArrowLeft className="h-5 w-5" />
        <span>{t('admin.navLinks.backToApp')}</span>
      </Link>
    );
  }

  // Style for desktop header (as a small button)
  return (
    <Link 
      to="/studio" 
      className={cn(
        buttonVariants({ variant: 'ghost', size: 'sm' }),
        'items-center gap-2 text-muted-foreground hover:text-foreground'
      )}
    >
      <ArrowLeft className="h-4 w-4" />
      <span className="text-sm">{t('admin.navLinks.backToApp')}</span>
    </Link>
  );
};